/* eslint-disable no-console */
import Vue from 'vue'
import { ToastProgrammatic as Toast } from 'buefy'

const notifyService = {
  show(prop) {
    Toast.open(prop)
  },
  fetch_error(dataType, error) {
    const type = Vue.i18n.translate(`attributes.${dataType}`)
    const message = Vue.i18n.translate('message.fetch_failed', [type])

    this.error(message, error)
  },
  create_error(error) {
    const message = Vue.i18n.translate('attributes.add_failed')

    this.error(message, error)
  },
  update_error(error) {
    const message = Vue.i18n.translate('attributes.update_failed')

    this.error(message, error)
  },
  modify_error(error) {
    const message = Vue.i18n.translate('attributes.modify_failed')

    this.error(message, error)
  },
  void_error(error) {
    const message = Vue.i18n.translate('attributes.void_failed')

    this.error(message, error)
  },
  delete_error(error) {
    const message = Vue.i18n.translate('attributes.delete_failed')

    this.error(message, error)
  },
  deprecate_error(error) {
    const message = Vue.i18n.translate('attributes.deprecate_failed')

    this.error(message, error)
  },
  gift_submit_error(error) {
    const message = Vue.i18n.translate('attributes.gift_submit_failed')

    this.error(message, error)
  },
  error(msg, error) {
    let message = `${msg}`
    if (error) {
      if (typeof error === 'string') {
        message = msg ? `${msg}: ${error}` : error
      } else if (typeof error === 'object') {
        if (error.status === 401) {
          message = error.message
        } else if (!error.status) {
          message = msg ? `${msg}: ${error.message}` : error.message
        } else {
          message = msg
            ? `(${error.status}) ${msg}: ${error.message}`
            : `(${error.status}) ${error.message}`
        }
      }
    }

    Toast.open({
      message,
      duration: 5000,
      position: 'is-top',
      type: 'is-danger',
      queue: false
    })
  },
  success(message, duration = 3000) {
    Toast.open({
      message,
      duration: duration,
      position: 'is-top',
      type: 'is-success'
    })
  }
}

export default notifyService
